export default "__VITE_ASSET__DcZixn9m__"